export default __webpack_public_path__ + "static/media/linkedin-original.cf7ffa37.svg";